<div class="saved-searches-form">
    <al-bottom-sheet #alBottomSheet [headerOptions]="headerOptions" (onPrimaryAction)="save()"
        (onSecondaryAction)="cancel()">
        <al-view-helper [loading]="loading"></al-view-helper>

        <div class="al-saved-search-form-content ui-fluid" *ngIf="!loading">
            <div class="p-grid">
                <div class="p-col-4">
                    <div class="p-grid p-dir-col">
                        <div class="p-col-12">
                            <h1 class="columnHeader">Saved Search Details</h1>
                        </div>
                        <div class="p-col input-report-name">
                            <span class="md-inputfield">
                                <input type="text" #ctrl="ngModel" class="p-col-12"
                                    [ngClass]="{'ng-dirty ng-invalid': !savedSearchProperties.name && ctrl.touched}"
                                    name="name" [(ngModel)]="savedSearchProperties.name"
                                    (ngModelChange)="validateForm()" pInputText />
                                <label for="float-input">Name *</label>
                            </span>
                        </div>
                        <br>
                        <div class="p-col input-report-name">
                            <span class="md-inputfield">
                                <input type="text" #ctrl="ngModel" class="p-col-12"
                                    name="description" [(ngModel)]="savedSearchProperties.description"
                                    (ngModelChange)="validateForm()" pInputText />
                                <label for="float-input">Description</label>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="p-col-4">
                    <div class="p-grid p-dir-col">
                        <div class="p-col-12">
                            <h1 class="columnHeader">Add Tags</h1>
                            <span class="p-col-12 section-title">
                                Optionally add existing tags or create new tags to organize your saved searches.
                            </span>
                        </div>
                        <div class="p-col">
                            <p-autoComplete
                                [(ngModel)]="savedSearchProperties.tags"
                                [suggestions]="suggestedTags"
                                (completeMethod)="setSuggestedTags($event)"
                                (onKeyUp)="onKeyUpTags($event)"
                                placeholder="Search or add tags"
                                [multiple]="true"
                            ></p-autoComplete>

                        </div>
                    </div>
                </div>
                <div class="p-col-4">
                    <div class="p-grid p-dir-col">
                        <div class="p-col-12">
                            <h1 class="columnHeader">Schedule Search</h1>
                            <span class="p-col-12 section-title">
                                Optionally create schedules for the search query to run automatically
                            </span>
                        </div>
                        <div class="p-col-12">
                            <div class="p-col">
                                <p-inputSwitch
                                    (onChange)="validateForm(); updateSaveButton()"
                                    [(ngModel)]="savedSearchProperties.createScheduledSearch"
                                    name="createScheduledSearch">
                                </p-inputSwitch>
                                <span class="padding-left-10">Create Scheduled Search (in next step)</span>
                            </div>
                            <div class="p-col">
                                <p-chips class="chips-edit-saved-search" [(ngModel)]="scheduleCadence" disabled>
                                    <ng-template let-item pTemplate="item">
                                        <span><strong>{{item}}</strong>&nbsp;Scheduled Search&nbsp;</span>
                                    </ng-template>
                                </p-chips>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="query-column p-col-12">
                <div class="p-grid p-dir-col">
                    <div class="p-col-12">
                        <h1 class="columnHeader">Search Query</h1>
                        <div class="monaco-editor-container">
                            <ngx-monaco-editor #editor
                                [options]="editorOptions"
                                [(ngModel)]="savedSearchProperties.search_request"
                                (init)="onMonacoEditorInit($event)">
                            </ngx-monaco-editor>
                        </div>
                        <button
                            *ngIf="editMode"
                            pButton type="button"
                            class="search-button"
                            label="EDIT IN SEARCH"
                            icon="ui-icon-chevron-right"
                            iconPos="right"
                            (click)="editInSearch()">
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </al-bottom-sheet>
</div>